<template>
	<div class="my-dfc layout-column">
		<!-- <div class="top">
			<course></course>
		</div> -->
		<div class="bottom row">
			<div class="board">
				<billboard></billboard>
			</div>
			<div class="information col">
				<challenge-info></challenge-info>
				<br>
				<br>
				<small style="max-width:400px;">
					【社團法人臺灣童心創意行動協會（下稱本協會） 告知事項】
					<br>
					<br>本協會將對完成報名組別之個人資料謹慎保護，並採取必要之保密措施，以維護報名者所提供資料之安全性。本協會之個人資料保密措施，係依據個人資料保護法以及主管機關之相關法令辦理，以善盡參與本活動或相關事務人員保密資料之職責：
					<br>
					<br>一、個人資料之儲存、保管及資料安全與維護方式：本協會將採取謹慎措施保護報名者資料，並依相關作業規範建立個人資料庫，按業務權責指定專門人員控管資料庫存取，以保護個人資料之安全性。任何未經本協會正式授權之人員，絕對禁止接觸報名者的個人資料。
					<br>
					<br>二、特定目的：本協會於本屆 DFC 挑戰活動範圍內蒐集及處理報名者的的個人資料，其特定目的為：049 非營利組織業務、058 社會服務或社會工作、063 非公務機關依法定義務所進行個人資料之蒐集處理及利用、069 契約、類似契約或其他法律關係事務、157 調查、統計與研究分析、181其他經營合於營業登記項目或組織章程所定之業務。 蒐集之個人資料類別：C001 辨識個人者、 C002 辨識財務者、C003政府資料中之辨識者、C011個人描述、C031 住家及設施、C038 職業等。
					<br>
					<br>三、本協會保有修訂保密措施與相關告知事項之權利，並將於網站或以其他主管機關認定公開揭露之管道公告揭露相關訊息，修訂時亦同；若有其他與保密措施相關之問題，請隨時洽詢本協會。
					<br>
					<br>四、其餘詳本協會網站之「<a href="https://tycaa.dfctaiwan.org/privacy" target="_blank">隱私權政策及服務條款</a>」。
				</small>
			</div>
		</div>

	</div>
</template>

<script>
import Course from "@/components/challenge/myDFC/Course";
import Billboard from "@/components/challenge/myDFC/Billboard";
import ChallengeInfo from "@/components/challenge/myDFC/ChallengeInfo";

export default {
	data() {
		return {}
	},
	computed: {},
	methods: {},
	created() { },
	mounted() { },
	components: {
		Course,
		Billboard,
		ChallengeInfo
	}
};
</script>

<style lang="scss" scoped>
.my-dfc {
	margin-bottom: 80px;

	.top {
		margin-bottom: 32px;
	}

	.board {
		margin-right: 20px;
	}
}
</style>